const fileDownloadButton = {
  title: 'Print selected QRCodes'
};

export default fileDownloadButton;
